module.exports = __webpack_public_path__ + "img/banner.2638bf93.png";